import React, { ReactNode } from 'react'
import { DispatchProp } from 'react-redux'
import { connectRedux } from '../../../helpers/connectRedux'
import { RouteComponentProps, withRouter } from '../../../helpers/withRouter'

import { Page, Spinner } from '../../../components'
import { images } from '../../../images'
import { urls } from '../../../routing'
import { LiteralsService } from '../../../services'
import { fetchMorePastReservationsAction, fetchPastReservationsAction, setQrCodeAndDetails, setSelectedReservationModalAction } from '../../../store/actions'
import { IStoreState } from '../../../store/states'
import { Card } from '../Reservations/Card'
import StyledSection from './styles'
import { AuthenticatedRoutable, IReservation } from '../../../models'
import { appsShowRefundsSectionSelected } from '../../../helpers/app'
import { AnyAction } from 'redux'

interface IProps extends DispatchProp<AnyAction>, RouteComponentProps {
  pastReservations: any[]
  isFetchingPastReservations: boolean
  isFetchingMorePastReservations: boolean
  isLoadMoreExist: boolean
  size: number,
  page: number
}

class PastReservations extends AuthenticatedRoutable<IProps> {
  private get emptyReservations(): ReactNode {
    return (
      <div className="empty-reservations">
        <img src={ images['noReservations'] } alt={ LiteralsService.get('noReservations') }/>
        <h3>{ LiteralsService.get('noReservations', true) }</h3>
        {/* <p>{ LiteralsService.get('noReservationsExplanation', true) }</p> */}
      </div>
    )
  }

  private get reservationsContent(): ReactNode {
    const { pastReservations, isFetchingPastReservations, isFetchingMorePastReservations } = this.props

    if (isFetchingPastReservations) {
      return (
        <article className="spinner-container">
          <Spinner />
        </article>
      )
    } else {
      if (!pastReservations.length) return this.emptyReservations
      return (
        <>
          {
            pastReservations.map((reservation, i) => (
              <Card
                key={ i }
                reservation={ reservation }
                onClick={ () => this.goToReservationDetails(reservation) }
                onFavoriteClick={ () => this.handleOpenFavoriteModal(reservation) }
                onQRClick={ () => this.handleOpenQRModal(reservation) }
              />
            ))
          }
          {
            isFetchingMorePastReservations &&
            <article className="spinner-container more">
              <Spinner />
            </article>
          }
        </>
      ) 
    }
  }

  public componentDidMount() {
    const { dispatch, size } = this.props
    super.componentDidMount()
    dispatch(fetchPastReservationsAction(size, 1))
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount(): void {
    window.removeEventListener('scroll', this.handleScroll)
  }

  public render(): ReactNode {

    const { history } = this.props

    return (
      <Page className={`authenticated`}>
        <StyledSection>
          <nav className="tabs">
            <div onClick={ () => history.push(urls.reservations) }>
              <span>{ LiteralsService.get('nextReservations', true) }</span>
            </div>
            <div className="divider" />
            <div className="active">
              <span>{ LiteralsService.get('pastReservations', true) }</span>
            </div>
            { appsShowRefundsSectionSelected?.show &&
              <>
                <div className="divider" />
                <div onClick={ () => history.push(urls.refundedReservations) }>
                  <span>{ LiteralsService.get('refunds', true) }</span>
                </div>
              </>
            }
          </nav>
          <div className='reservations' onScroll={this.handleScroll} >
            { this.reservationsContent }
          </div>
        </StyledSection>
      </Page>
    )
  }
  
  private goToReservationDetails = (reservation: IReservation) => {
    this.props.history.push(
      `${ urls.reservationDetails }/${ reservation.id }`,
      { id: reservation.id, cancelled: reservation.cancelled }
    )
  }

  private handleOpenFavoriteModal = (reservation?: IReservation) => {
    this.props.dispatch(setSelectedReservationModalAction(reservation ?? null))
  }
  
  private handleOpenQRModal = (reservation: IReservation) => {
    const { dispatch } = this.props
    dispatch(setQrCodeAndDetails(reservation))
  }

  private handleScroll = (e: any) => {
    const { dispatch, size, page, isLoadMoreExist, isFetchingMorePastReservations } = this.props
    const bottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight;
    if (bottom && isLoadMoreExist && !isFetchingMorePastReservations) {
      dispatch(fetchMorePastReservationsAction(size, page))
    }
  }
}

const mapStateToProps = ({ reservations }: IStoreState) => ({
  pastReservations: reservations.pastReservations,
  isFetchingPastReservations: reservations.isFetchingPastReservations,
  isFetchingMorePastReservations: reservations.isFetchingMorePastReservations,
  isLoadMoreExist: reservations.isLoadMoreExist,
  size: reservations.size,
  page: reservations.page
})

export default withRouter(connectRedux(mapStateToProps, PastReservations))
